import HeaderSection from "../components/shared/HeaderSection";
import AboutSection from "../components/about/AboutSection";
import TeamSection from "../components/about/TeamSection";
import CTASection from "../components/about/CTASection";

const About = () => {
  return (
    <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      {/* Header Section */}
      <HeaderSection
        image="/images/bg-images/about-bg.jpeg"
        header="About Us"
        subHeader="Innovating with Excellence – Our Journey & Vision"
      />

      {/* Main Content */}
      {/* <div className="container mx-auto px-6 py-12"> */}
        {/* About Us Section */}
        <AboutSection />

        {/* Our Team Section */}
        <TeamSection />
        
        <CTASection />
      {/* </div> */}
    </section>
  );
};

export default About;